const ITEMS = [
  "Manufacturing",
  "Distribution",
  "Online",
  "Institute of Management Studies",
  "ISO 9001:2015 Certified",
  "FSSAI Registered",
  "30+ Years of Trust",
];

const Row = ({ hidden = false }) => (
  <div aria-hidden={hidden} className="flex w-max shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="px-8 font-display text-2xl font-medium tracking-wide text-slate-200 sm:text-3xl lg:text-4xl">
          {item}
        </span>
        <span className="h-2.5 w-2.5 rotate-45 bg-brand-red" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div className="relative overflow-hidden border-y border-white/5 bg-surface py-8">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row hidden />
    </div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-ink to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-ink to-transparent" />
  </div>
);

export default Marquee;
